const menus = [
  {
    id: 1,
    name: "Naslovna",
    links: "/",
  },
  {
    id: 2,
    name: "Novosti",
    namesub: [
      {
        id: 1,
        sub: "Unos Novosti",
        links: "/admin/news-edit",
      },
      {
        id: 2,
        sub: "Pregled Novosti",
        links: "/admin/news-list",
      },
    ],
  },
  {
    id: 3,
    name: "Gradovi",
    namesub: [
      {
        id: 1,
        sub: "Unos Gradova",
        links: "/admin/cities-edit",
      },
      {
        id: 2,
        sub: "Pregled Gradova",
        links: "/admin/cities-list",
      },
    ],
  },
];

export default menus;
